import { render } from "./OldList.vue?vue&type=template&id=cf1b3ece"
import script from "./OldList.vue?vue&type=script&lang=js"
export * from "./OldList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__